(function () {
	'use strict';

	angular.module('qbePortal').directive('qbThankYou',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbThankYou.html',
				restrict: 'E',
				scope: {
					thankYou: "=",
					isEligible: "=",
					isConfirmed: '=',
					coreData: '=',
					showThankYou: '=',
					promoData: '=',
		     		textDisplay:'=',
		     		ctpStepTotal:'=',
		     		ctpStepNum:'=',
		     		ctpCompleted:'='										
				},
			    transclude: true,							
				link: function (scope, element, attrs) {					
							
				}
			};
		});

})();
